export default {"src":"/_next/static/media/gebote.2076624f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};